// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N3sZ","rootMobile":"styles_rootMobile__3-H_O"};